import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    mainContainerHorizontal: {
        height: '1080px',
        width: '13440px',
        position: 'relative',
    },
    screenHorizontal: {
        width: '1920px',
        height: '100%',
        display: 'inline-block',
        verticalAlign: 'top',
    },
    mainContainerVertical: {
        height: '7560px',
        width: '1920px',
        position: 'relative',
    },
    screenVertical: {
        height: '1080px',
        width: '100%',
        display: 'inline-block',
        verticalAlign: 'top',
    },
})

export default useStyles
